import Login from '../../components/Login'

const index = () => {
  return <Login />
}

export default index
